import { financeAPI } from "../../axios";

export const actions = {
  createDisbursement(context, data) {
    return financeAPI.post("Disbursement/Create", data);
  },
  getSingleDisbursement(context, id) {
    return financeAPI.get(`Disbursement/${id}`);
  },
  updateDisbursement(context, data) {
    return financeAPI.put(`Disbursement/${data.id}`, data);
  },
  deleteDisbursement(context, id) {
    return financeAPI.delete(`Disbursement/${id}`);
  },
  postDisbursement(context, data) {
    return financeAPI.put(`Disbursement/Post/${data.id}`, {dateTime: data.dateTime});
  },
  approveDisbursement(context, id) {
    return financeAPI.put(`Disbursement/Approve/${id}`);
  },
  returnDisbursement(context, id) {
    return financeAPI.put(`Disbursement/Return/${id}`);
  },
  submitDisbursement(context, id){
    return financeAPI.put(`Disbursement/Submit/${id}`)
  },
  getPendingDisbursements(context, { cycle, campusId }) {
    return financeAPI.get(`Disbursement/Pending/${cycle}/${campusId}`);
  },
  getApprovedDisbursements(context, { cycle, campusId }) {
    return financeAPI.get(`Disbursement/Approved/${cycle}/${campusId}`);
  },
  getSubmittedDisbursement(context, {cycle, campusId}){
    return financeAPI.get(`Disbursement/Submitted/${cycle}/${campusId}`)
  },
  getPostedDisbursements(context, { cycle, campusId }) {
    return financeAPI.get(`Disbursement/Posted/${cycle}/${campusId}`);
  },
  getAvailableBurs(context, { cycle, campusId }) {
    return financeAPI.get(`Disbursement/Available/Burs/${cycle}/${campusId}`);
  },
  getActualCashTransaction(context, BursId) {
    return financeAPI.get(`ActualCashTransaction/Burs/${BursId}`);
  },
  getReturnedDisbursements(context, { cycle, campusId }) {
    return financeAPI.get(`Disbursement/Returned/${cycle}/${campusId}`);
  },
  getUnreleasedDisbursement(context, {cycle, campusId}){
    return financeAPI.get(`Disbursement/Unrelease/${cycle}/${campusId}`)
  },
  updateRelease(context, data){
    return financeAPI.put(`Disbursement/Release/${data.id}`, data)
  }
};
